export const CII_DATA = {
	CLIENT_EXCLUSIONS_HEADER:
		"CII YTD value if different from above estimated CII value (client input if they disagree with portal calculated value) The values input by client here will override portal estimated CII values above)",
	CII_EXCLUSIONS_HEADER:
		"CII YTD value at the date of last voyages entry in DCS child report.(cut off at 31st Dec 23:59 hrs)(value includes partial year reporting data above)",
	REQUIRED_CII_TEXT: "Required CII of vessel",
	ATTAINED_WITHOUT_EXCLUSIONS_TEXT:
		"Estimated Attained CII without exclusion",
	ATTAINED_WITH_EXCLUSIONS_TEXT: "Estimated Attained CII with exclusion",
	GRADES_WITHOUT_EXCLUSIONS_TEXT:
		"CII grade based on estimated CII without exclusion",
	GRADES_WITH_EXCLUSIONS_TEXT:
		"CII grade based on estimated CII with exclusion",
	CONFIRM_BTN_MNL_CII_UPDATE: "Confirm manual update of CII values",
	REMOVE_BTN_MNL_CII_UPDATE: "Remove manual update of CII values",
	INPUT_CLIENT: "(input by client)",
	CALCULATED_PORTAL_INFO: "(calculated by portal based on above info)",
	CONFIRM_PARTIAL_REPORT: "Confirm partial reporting CII information",
	REMOVE_PARTIAL_REPORT: "Remove partial reporting CII information",
	FUEL_CONS_EXCLUSION: "Fuel consumption with Exclusion",
	NOTE: "Note: please upload supporting documents/calculations for CII values in 'Documents' tab",
};

export const PARTIAL_REPORT_DATA = {
	PARTIAL_REPORTING_YEAR:
		"Partial report reporting year CII data due to change of management",
	PARTIAL_REPORT_HEADER:
		"Partial report reporting year CII data due to change of management.",
	REPORTING_YEAR: "Partial report reporting year",
	REPORT_START_DATE: "Partial report start date",
	REPORT_END_DATE: "Partial report end date",
	DISTANCE_TRAVELLED: "Distance travelled",
	DISTANCE_EXCLUDED: "Distance excluded",
};

export const FUEL_CONSUMPTION_HEADERS = [
	{
		fuelInfo: "Fuel Type",
	},
	{
		fuelInfo: "Fuel Consumed",
	},
	{
		fuelInfo: "Cf",
	},
	{
		fuelInfo: "Fc Voyage",
	},
	{
		fuelInfo: "Tfi",
	},
	{
		fuelInfo: "Fc Electric",
	},
	{
		fuelInfo: "Fc Boilers",
	},
	{
		fuelInfo: "Fc Others",
	},
];

export const FUEL_CONSUMPTION = [
	{
		fuelType: "HFO",
		cfValue: 3.114,
		defaultValue: "0.00",
	},
	{
		fuelType: "LFO",
		cfValue: 3.151,
		defaultValue: "0.00",
	},
	{
		fuelType: "MDO",
		cfValue: 3.206,
		defaultValue: "0.00",
	},
	{
		fuelType: "MGO",
		cfValue: 3.206,
		defaultValue: "0.00",
	},
	{
		fuelType: "LPG(Propone)",
		cfValue: "3.000",
		defaultValue: "0.00",
	},
	{
		fuelType: "LPG(Butane)",
		cfValue: 3.03,
		defaultValue: "0.00",
	},
	{
		fuelType: "LNG",
		cfValue: 2.75,
		defaultValue: "0.00",
	},
	{
		fuelType: "Methanol",
		cfValue: 1.375,
		defaultValue: "0.00",
	},
	{
		fuelType: "Ethanol",
		cfValue: 1.913,
		defaultValue: "0.00",
	},
	{
		fuelType: "Other Fuel type 1",
		cfValue: "",
		defaultValue: "0.00",
	},
	{
		fuelType: "Other Fuel type 2",
		cfValue: "",
		defaultValue: "0.00",
	},
	{
		fuelType: "Other Fuel type 3",
		cfValue: "",
		defaultValue: "0.00",
	},
];
